import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

export default function FreeSoloCreateOption(props) {
    const { id, label, value, setValue } = props;

    return (
        <Autocomplete
            style={{ display: 'contents' }}
            value={value}
            onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                    setValue({
                        farm_name: newValue,
                    });
                } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setValue({
                        farm_name: newValue.inputValue,
                    });
                } else {
                    setValue(newValue);
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.farm_name);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        farm_name: `Add "${inputValue}"`,
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id={id}
            options={farmList}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }
                // Regular option
                return option.farm_name;
            }}
            renderOption={(props, option) => <li {...props}>{option.farm_name}</li>}
            // sx={{ width: 300 }}
            freeSolo
            renderInput={(params) => (
                <TextField {...params} label={label} />
            )}
        />
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const farmList = [
    {
        farm_name: "Organic Valley Farms",
        location: {
            lat: 11.016844,
            lng: 76.955832,
            name: "Coimbatore Farmstead"
        }
    },
    {
        farm_name: "Nature's Best",
        location: {
            name: "Tiruchirappalli Farmstead",
            lat: 10.790483,
            lng: 78.704673
        }
    },
    {
        farm_name: "Sunshine Farms",
        location: {
            name: "Salem Farmstead",
            lat: 11.664325,
            lng: 78.146014
        }
    },
    {
        farm_name: "Happy Harvest",
        location: {
            lat: 11.341036,
            lng: 77.717164,
            name: "Erode Farmstead"
        }
    },
    {
        farm_name: "Fresh Fields",
        location: {
            name: "Thanjavur Farmstead",
            lat: 10.787037,
            lng: 79.137772
        }
    },
    {
        farm_name: "Golden Acres",
        location: {
            name: "Vellore Farmstead",
            lat: 12.916516,
            lng: 79.132499
        }
    },
    {
        farm_name: "Bountiful Harvest",
        location: {
            lat: 10.367312,
            lng: 77.98029,
            name: "Dindigul Farmstead"
        }
    },
    {
        farm_name: "Green Pastures",
        location: {
            lat: 8.764166,
            lng: 78.134835,
            name: "Thoothukudi Farmstead"
        }
    },
    {
        farm_name: "Healthy Harvest",
        location: {
            lat: 8.713912,
            lng: 77.756652,
            name: "Tirunelveli Farmstead"
        }
    }
];
